/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterTask } from '../../models/work-center-task';

export interface GetByWorkCenterTaskId$Params {
  workCenterTaskId: number;
}

export function getByWorkCenterTaskId(http: HttpClient, rootUrl: string, params: GetByWorkCenterTaskId$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterTask>> {
  const rb = new RequestBuilder(rootUrl, getByWorkCenterTaskId.PATH, 'get');
  if (params) {
    rb.path('workCenterTaskId', params.workCenterTaskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterTask>;
    })
  );
}

getByWorkCenterTaskId.PATH = '/api/v1/Tasks/{workCenterTaskId}/ByWorkCenterTaskId';
